import { Form as FormikForm, Formik, FormikValues } from 'formik';
import { ForwardedRef, forwardRef, ReactNode } from 'react';
import * as yup from 'yup';
import FormValues from '../FormValues';

type AnyObject = Record<string, any>; // NOSONAR

interface Props {
  initialValues: AnyObject;
  onSubmit: (...args: any) => void; // NOSONAR
  // validationSchema?: ReturnType<typeof yup.object>;
  validationSchema?: yup.AnyObjectSchema;
  id?: string;
  enableReinitialize?: boolean;
  children?: ReactNode;
  setFormValue?: React.Dispatch<any>;
  setFormikContext?: React.Dispatch<any>;
  formikContext?: any;
  onFormValuesChange?: (value: FormikValues) => void;
}

const Form = forwardRef(
  (
    {
      initialValues,
      onSubmit,
      validationSchema,
      children,
      id,
      enableReinitialize = false,
      setFormValue,
      setFormikContext,
      formikContext,
      onFormValuesChange
    }: Props,
    ref: ForwardedRef<HTMLFormElement>
  ) => {
    return (
      <Formik
        enableReinitialize={enableReinitialize}
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {formikProps => {
          setFormikContext && !formikContext && setFormikContext(formikProps);
          return (
            <FormikForm
              id={id}
              onSubmit={formikProps.handleSubmit}
              ref={ref}
              onChange={(e: AnyObject) => {
                if (onFormValuesChange && typeof onFormValuesChange === 'function') {
                  const key = e.target.name || e.target.id;
                  onFormValuesChange({ ...formikProps.values, [key]: e.target.value });
                }
              }}
            >
              {setFormValue ? <FormValues setFormValue={setFormValue} /> : null}
              {children}
            </FormikForm>
          );
        }}
      </Formik>
    );
  }
);

Form.displayName = 'Form';
export default Form;
